module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//entry.png?v=dc3b18e2";